export default __webpack_public_path__ + "static/media/dollarIcon(Red).a5b120b3.png";